<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{ 'menu_export_report.create_report_use_labor' | translate }}
    </mat-card-title>
  </mat-card-header>

  <form #f="ngForm" [formGroup]="actionForm" class="pb-3">
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
      <mat-accordion>
        <mat-expansion-panel expanded="true" class="mt-3">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ 'menu_export_report.search_info_create' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row">
            <!-- Kỳ báo cáo -->
            <div class="col-3">
              <mat-form-field class="w-100">
                <mat-select id="reportPeriod" name="reportPeriod"
                  [placeholder]="'menu_export_report.table.report_period' | translate" formControlName="reportPeriod"
                  required>
                  <mat-option *ngFor="let itemSelect of listReportPeriod" [value]="itemSelect.value">
                    {{ itemSelect.labelKey | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Năm báo cáo -->
            <div class="col-3">
              <mat-form-field class="w-100" appYearFormat>
                <mat-label>{{ 'menu_export_report.report_year' | translate }}</mat-label>
                <input matInput #yearInput formControlName="reportYear" [matDatepicker]="pickerReportYear"
                  [max]="maxDate" maxlength="4" placeholder="YYYY" (keypress)="onlyNumber($event)"
                  (input)="onYearChange()" />

                <!-- Bổ sung [disabled] vào mat-datepicker-toggle -->
                <mat-datepicker-toggle matSuffix [for]="pickerReportYear"
                  [disabled]="actionForm.get('reportYear')?.disabled">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #pickerReportYear startView="multi-year"
                  (yearSelected)="chosenYearHandler($event, pickerReportYear)">
                </mat-datepicker>

                <!-- Quản lý hiển thị thông báo lỗi -->
                <mat-error *ngIf="actionForm.controls['reportYear'].hasError('futureYear')">
                  <span class="text-error">{{ 'menu_export_report.validation.futureYear' | translate }}</span>
                </mat-error>

                <mat-error
                  *ngIf="!actionForm.controls['reportYear'].hasError('futureYear') && (actionForm.controls['reportYear'].hasError('invalidYearFormat') || actionForm.controls['reportYear'].hasError('matDatepickerParse'))">
                  <span class="text-error">{{ 'menu_export_report.validation.invalidYearFormat' | translate }}</span>
                </mat-error>
              </mat-form-field>
            </div>
            <!-- Từ ngày -->
            <div class="col-3" *ngIf="actionForm?.get('reportPeriod')?.value === 3">
              <mat-form-field class="w-100">
                <mat-label>
                  {{ 'menu_export_report.data_from_date' | translate }}
                  <span *ngIf="actionForm.get('reportPeriod')?.value === 3" class="text-danger">*</span>
                </mat-label>
                <input matInput [matDatepicker]="fromDate" name="fromDate" [max]="actionForm.controls['toDate'].value || today" [errorStateMatcher]="matcher"
                  (focus)="lastTouchedField = 'fromDate'"
                  (blur)="actionForm.controls['fromDate'].markAsTouched(); onDateInputChange('fromDate', pickerFromDateInput, actionForm.controls['fromDate'])"
                  (dateChange)="onDateInputChange('fromDate', pickerFromDateInput, actionForm.controls['fromDate']); clearListData()"
                  (change)="onDateInputChange('fromDate', pickerFromDateInput, actionForm.controls['fromDate']); clearListData()"
                  formControlName="fromDate" [ngClass]="{ 'is-invalid': actionForm.controls['fromDate'].invalid }"
                  maxlength="10" #pickerFromDateInput>
                <mat-datepicker-toggle matSuffix [for]="fromDate">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                    [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #fromDate></mat-datepicker>

                <mat-error>
                  <span class="text-error">
                    {{ getErrorMessageV2(pickerFromDateInput.value, true, 'fromDate') }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Đến ngày -->
            <div class="col-3" *ngIf="actionForm?.get('reportPeriod')?.value === 3">
              <mat-form-field class="w-100">
                <mat-label>
                  {{ 'menu_export_report.data_to_date' | translate }}
                  <span *ngIf="actionForm.get('reportPeriod')?.value === 3" class="text-danger">*</span>
                </mat-label>
                <input matInput [matDatepicker]="toDate" name="toDate"        
                  [min]="actionForm.controls['fromDate'].value"
                  [max]="today" [errorStateMatcher]="matcher"
                  (focus)="lastTouchedField = 'toDate'"
                  (blur)="actionForm.controls['toDate'].markAsTouched(); onDateInputChange('toDate', pickerToDateInput, actionForm.controls['toDate'])"
                  (dateChange)="onDateInputChange('toDate', pickerToDateInput, actionForm.controls['toDate']); clearListData()"
                  (change)="onDateInputChange('toDate', pickerToDateInput, actionForm.controls['toDate']); clearListData()"
                  formControlName="toDate" [ngClass]="{ 'is-invalid': actionForm.controls['toDate'].invalid }"
                  maxlength="10" #pickerToDateInput>
                <mat-datepicker-toggle matSuffix [for]="toDate">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                    [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #toDate></mat-datepicker>

                <mat-error>
                  <span class="text-error">
                    {{ getErrorMessageV2(pickerToDateInput.value, true, 'toDate') }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Nâng cao: Tên/Mã HĐLD -->
            <div class="col-3" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <input (focusout)="focusOut('contractSearch')" #focusInput matInput type="text"
                  [placeholder]="'menu_export_report.name_code_contract' | translate" maxlength="255" autocomplete="off"
                  formControlName="contractSearch" />
                <button mat-button *ngIf="actionForm?.controls?.contractSearch?.value" type="button" matSuffix
                  mat-icon-button aria-label="Clear" (click)="clearData('contractSearch')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Nâng cao: Tên/Mã/Email ký kết -->
            <div class="col-3" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <input (focusout)="focusOut('signerSearch')" #focusInput matInput type="text"
                  [placeholder]="'menu_export_report.name_code_sign' | translate" maxlength="255" autocomplete="off"
                  formControlName="signerSearch" />
                <button mat-button *ngIf="actionForm?.controls?.signerSearch?.value" type="button" matSuffix
                  mat-icon-button aria-label="Clear" (click)="clearData('signerSearch')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Toggle nâng cao / cơ bản -->
            <div *ngIf="!isBasicSearchForm" class="col-lg-12 col-md-6 d-flex justify-content-end">
              <button type="button" mat-button class="advance-search" (click)="onCloseAdvancedSearchForm()">
                <span>{{'enterprise_contract.buttons.basic' | translate}}</span>
                <em class="material-icons">keyboard_arrow_up</em>
              </button>
            </div>

            <div *ngIf="isBasicSearchForm" class="col-lg-12 col-md-6 d-flex justify-content-end">
              <button type="button" mat-button class="advance-search" (click)="onExpandAdvancedSearchForm()">
                <span>{{'enterprise_contract.buttons.advance' | translate}}</span>
                <em class="material-icons">keyboard_arrow_down</em>
              </button>
            </div>

            <!-- Button Tìm kiếm -->
            <div class="col-lg-12 col-md-6 d-flex justify-content-center">
              <div class="row mt-3">
                <div class="col-lg-12 d-flex align-items-center justify-content-center">
                  <button mat-stroked-button color="primary" appTrackEvent="w.btn.hdtoilap.tim_kiem"
                    (click)="loadData()">
                    <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                    {{'enterprise_contract.buttons.search' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- Bảng danh sách tài liệu -->
      <mat-accordion [multi]="true">
        <mat-expansion-panel expanded="true" class="mt-3">
          <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
            <span>
              {{ "menu_export_report.title_table_in_create" | translate }}
              <span style="color: #dc3545; font-weight: bold;">({{ dataSelected ? dataSelected.size : 0 }})</span>
            </span>
          </mat-panel-title>

          <div class="mat-table-container">
            <table mat-table [dataSource]="listDataSource" matSort class="reponsive-table mb-3">
              <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef
                  class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                  style="min-width: 50px; max-width: 50px;">
                  <mat-checkbox *ngIf="listDataSource && listDataSource.data && listDataSource.data.length > 0"
                    [(ngModel)]="checkAll" [ngModelOptions]="{standalone: true}" (change)="checkAllCheckBox()"
                    color="primary">
                  </mat-checkbox>
                </mat-header-cell>

                <mat-cell *matCellDef="let element"
                  class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                  style="min-width: 50px; max-width: 50px;" (click)="$event.stopPropagation()">
                  <mat-checkbox color="primary" [(ngModel)]="element.checked" [ngModelOptions]="{standalone: true}"
                    (change)="onSelect(element)">
                  </mat-checkbox>
                </mat-cell>
              </ng-container>
              <!-- STT -->
              <ng-container matColumnDef="stt">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="min-width: 50px; max-width: 50px;">
                  {{ "headertable.stt" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index" style="min-width: 50px; max-width: 50px;">
                  {{ paginate.currentPage * paginate.pageSize + i + 1 }}
                </mat-cell>
              </ng-container>
              <!-- UUID hợp đồng lao động -->
              <ng-container matColumnDef="uuid">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="min-width: 160px; max-width: 160px;">
                  {{ "menu_export_report.table.uuid" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index"
                  [matTooltip]="displayTooltip(element.idMoha, i, 'uuid')"
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                  style="min-width: 160px; max-width: 160px;">
                  <span class="fix-width fw-100 uuid">
                    {{ element.idMoha }}
                  </span>
                </mat-cell>
              </ng-container>
              <!-- Hợp đồng lao động (Tên / Mã HĐLĐ) -->
              <ng-container matColumnDef="contractName">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="min-width: 200px; max-width: 200px;">
                  {{ "menu_export_report.table.name_contract" | translate }}
                </mat-header-cell>

                <mat-cell *matCellDef="let element; let i = index"
                  [matTooltip]="displayTooltip(element.contractCode + ' - ' + element.contractName, i, 'name')"
                  class="mat-cell-non-boder-right-bottom cell"
                  style="min-width: 200px; max-width: 200px; justify-content: flex-start; text-align: left !important;"
                  matTooltipClass="tooltip-break">
                  <span class="fix-width fw-100 name" style="text-align: left !important; display: block; width: 100%;">
                    {{ element.contractCode}} - {{element.contractName }}
                  </span>
                </mat-cell>
              </ng-container>
              <!-- Các bên ký hợp đồng -->
              <ng-container matColumnDef="signers">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="min-width: 200px; max-width: 200px;">
                  {{ "menu_export_report.table.signatory_parties" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                  style="min-width: 200px; max-width: 200px;" [matTooltip]="element.allName">
                  <span class="fix-width fw-100">
                    {{ element.allName }}
                  </span>
                </mat-cell>
              </ng-container>
              <!-- Trạng thái -->
              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="min-width: 120px; max-width: 120px;">
                  {{ "menu_export_report.status" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                  style="min-width: 120px; max-width: 120px;">
                  <nz-tag *ngIf="+element.statusCode === 4"
                  [nzColor]="'green'" style="margin-right: 0px;">{{'menu_export_report.status_select.completed' | translate}}
                </nz-tag>
                </mat-cell>
              </ng-container>
              <!-- Trạng thái chứng thực -->
              <ng-container matColumnDef="authStatus">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="min-width: 160px; max-width: 160px;">
                  {{ "menu_export_report.auth_status" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                  style="min-width: 160px; max-width: 160px;">
                  <nz-tag *ngIf="+element.signStatusCode === 1" style="margin-right: 0px;">
                    {{'contract_terminate.no_sign' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.signStatusCode === 2 || +element.signStatusCode === 4" [nzColor]="'blue'" style="margin-right: 0px;">
                    {{'contract_terminate.signing' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.signStatusCode === 3" [nzColor]="'red'" style="margin-right: 0px;">
                    {{'contract_terminate.failed' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.signStatusCode === 6" [nzColor]="'green'" style="margin-right: 0px;">
                    {{'contract_terminate.signed' | translate}}
                  </nz-tag>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="platformStatus">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="min-width: 180px; max-width: 200px;">
                  {{ "menu_export_report.send_status_hdld" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                  style="min-width: 180px; max-width: 200px;">
                  <nz-tag *ngIf="+element.sendMohaStatusCode === 1" style="margin-right: 0px;">
                    {{'contract_terminate.no_send' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.sendMohaStatusCode === 2" [nzColor]="'blue'" style="margin-right: 0px;">
                    {{'contract_terminate.sending' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.sendMohaStatusCode === 3" [nzColor]="'red'" style="margin-right: 0px;">
                    {{'contract_terminate.failed' | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="+element.sendMohaStatusCode === 4" [nzColor]="'green'" style="margin-right: 0px;">
                    {{'contract_terminate.sent' | translate}}
                  </nz-tag>
                </mat-cell>
              </ng-container>
              <!-- Ngày lập -->
              <ng-container matColumnDef="createdDate">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="min-width: 130px; max-width: 130px;">
                  {{ "menu_export_report.table.creation_date" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                  style="min-width: 130px; max-width: 130px;">
                  <span>
                    {{ element.createdDate | date: 'dd/MM/yyyy' }}
                  </span>
                </mat-cell>
              </ng-container>

              <!-- Ngày hiệu lực -->
              <ng-container matColumnDef="effectiveDate">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="min-width: 130px; max-width: 130px;">
                  {{ "menu_export_report.effective_date" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                  style="min-width: 130px; max-width: 130px;">
                  <span>
                    {{ element.effectiveDate | date: 'dd/MM/yyyy' }}
                  </span>
                </mat-cell>
              </ng-container>

              <!-- Ngày hết hiệu lực -->
              <ng-container matColumnDef="expiredDate">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="min-width: 130px; max-width: 130px;">
                  {{ "menu_export_report.expired_date" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                  style="min-width: 130px; max-width: 130px;">
                  <span>
                    {{ element.expiredDate | date: 'dd/MM/yyyy' }}
                  </span>
                </mat-cell>
              </ng-container>

              <!-- Dynamic Columns (Cột động nếu có) -->
              <ng-container *ngFor="let col of dynamicColumns" [matColumnDef]="col.code">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{ col.name }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell">
                  <span class="fix-width fw-100" [matTooltip]="element[col.code]" matTooltipClass="tooltip-break">
                    {{ element[col.code] }}
                  </span>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns" class="element-row"></mat-row>
            </table>
          </div>
          <!-- Pagination -->
          <app-pagination class="my-pagination" [(paginate)]="paginate"
            (pageChange)="onPageChange($event.page, $event.pageSize)">
          </app-pagination>
        </mat-expansion-panel>
        <!-- Thao tác Footer -->
        <mat-card-actions class="d-flex justify-content-center align-items-center gap-2 mt-3">
          <button type="button" mat-stroked-button class="btn-custom btn-back" (click)="onBack()">
            <mat-icon>reply</mat-icon>
            {{ "menu_export_report.buttons.btn_back" | translate }}
          </button>

          <button type="button" mat-raised-button [disabled]="!listDataSource?.data?.length"
            class="btn-custom btn-export-selected" (click)="exportAll()">
            <mat-icon>file_upload</mat-icon>
            {{ "menu_export_report.buttons.btn_export_all" | translate }}
          </button>

          <button type="button" mat-raised-button class="btn-custom btn-export-selected"
            [disabled]="!dataSelected || dataSelected.size === 0" (click)="exportSelected()">
            <mat-icon>send</mat-icon>
            {{ "menu_export_report.buttons.btn_export_selected" | translate }}
          </button>
        </mat-card-actions>
      </mat-accordion>
    </mat-card-content>
  </form>
</mat-card>